module.exports = __webpack_public_path__ + "img/3.6de543d6.jpg";